@for (item of [].constructor(3); track item) {
  <div class="card">
    <ui-skeleton-loader-legacy class="name" [theme]="{ height: '1rem', width: '40%' }" />
    <ui-skeleton-loader-legacy class="label" [theme]="{ height: '1rem', width: '50%' }" />
    <ui-skeleton-loader-legacy class="description" [theme]="{ height: '4rem' }" />
    <ui-skeleton-loader-legacy class="price" [theme]="{ height: '1.5rem', width: '40%' }" />
    <ui-skeleton-loader-legacy
      class="visibility mobile-only"
      [theme]="{ height: '2rem', width: '30%' }"
    />
    <ui-skeleton-loader-legacy class="action" [theme]="{ height: '2rem' }" />
    <ui-skeleton-loader-legacy class="action" [theme]="{ height: '2rem' }" />
  </div>
}
